<h3 class="page">{{ 'label.InfoPages' | translate }}</h3>
<div class="container container-custom">
  <div class="row">
    <div *ngFor="let item of providerWebsites">
      <div class="col-sm-4">
        <div class="well">
          <div class="well-content-header">
            {{ item.name }}
          </div>
          <hr />
          <div class="well-content">
            <ul>
              <li class="list-item" *ngFor="let title of titleData">
                <a
                  class="list-item-link"
                  (click)="
                    onEdit(item.providerWebsiteId, item.name, title.title)
                  "
                >
                  {{ 'label.' + title.title | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
